import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=ba4c229a&"
import script from "./BarChart.vue?vue&type=script&lang=ts&"
export * from "./BarChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba4c229a')) {
      api.createRecord('ba4c229a', component.options)
    } else {
      api.reload('ba4c229a', component.options)
    }
    module.hot.accept("./BarChart.vue?vue&type=template&id=ba4c229a&", function () {
      api.rerender('ba4c229a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data-view/components/BarChart.vue"
export default component.exports